/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
  $('.product-single__content-text').addClass('js-tabs-built');
});

$('.size-chart-link').click(function(e){
    $('#acc-1').addClass("js-active").stop().slideDown();
      $('html, body').animate({ scrollTop : $('#acc-1').offset().top }, 'slow');
});

$(init);   
function init() {
  $("afterpay-placement").css({'--logo-badge-width': '70px', '--messaging-line-height': '0.9'});
}


// FADESHOW // Simple fade gallery for payment options
$(".fadeShow").each(function() {

  var $slides = $(this).children(),
      tot = $slides.length,
      itv = null,
      idx = 0; 
      
  $slides.eq(idx).show();
  
  function anim() { $slides.fadeOut().eq(++idx % tot).fadeIn(); }
  function play() { itv = setInterval(anim, 4000); }
  function stop() { clearInterval(itv); }
  
  $(this).hover(stop, play);
  
  play();
  
});


// Cart upsell cookies

var setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
var getCookie = function(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
$(document).ready(function($) {
  console.log(getCookie("activewash-closed"));
  if (getCookie("activewash-closed") == "activewash-closed") {
    $(".grangers-productbox.activewash").hide();
  }
  $(".grangers-productbox.activewash .close").click(function(){
  $(".grangers-productbox.activewash").fadeOut();
    event.preventDefault()
  setCookie("activewash-closed", "activewash-closed", 2)
});
});
$(document).ready(function($) {
  console.log(getCookie("repel-closed"));
  if (getCookie("repel-closed") == "repel-closed") {
    $(".grangers-productbox.repel").hide();
  }
  $(".grangers-productbox.repel .close").click(function(){
  $(".grangers-productbox.repel").fadeOut();
    event.preventDefault()
  setCookie("repel-closed", "repel-closed", 2) 
});
});
$(document).ready(function($) {
  console.log(getCookie("cyclops-closed"));
  if (getCookie("cyclops-closed") == "cyclops-closed") {
    $(".grangers-productbox.cyclops").hide();
  }
  $(".grangers-productbox.cyclops .close").click(function(){
  $(".grangers-productbox.cyclops").fadeOut();
    event.preventDefault()
  setCookie("cyclops-closed", "cyclops-closed", 2) 
});
});
$(document).ready(function($) {
  console.log(getCookie("shield-closed"));
  if (getCookie("shield-closed") == "shield-closed") {
    $(".grangers-productbox.shield").hide();
  }
  $(".grangers-productbox.shield .close").click(function(){
  $(".grangers-productbox.shield").fadeOut();
    event.preventDefault()
  setCookie("shield-closed", "shield-closed", 2) 
});
});
$(document).ready(function($) {
  console.log(getCookie("dark-camo-jersey-upsell-closed"));
  if (getCookie("dark-camo-jersey-upsell-closed") == "dark-camo-jersey-upsell-closed") {
    $(".grangers-productbox.dark-camo-jersey-upsell").hide();
  }
  $(".grangers-productbox.dark-camo-jersey-upsell .close").click(function(){
  $(".grangers-productbox.dark-camo-jersey-upsell").fadeOut();
    event.preventDefault()
  setCookie("dark-camo-jersey-upsell-closed", "dark-camo-jersey-upsell-closed", 2) 
});
});
$(document).ready(function($) {
  console.log(getCookie("dark-camo-gloves-upsell-closed"));
  if (getCookie("dark-camo-gloves-upsell-closed") == "dark-camo-gloves-upsell-closed") {
    $(".grangers-productbox.dark-camo-gloves-upsell").hide();
  }
  $(".grangers-productbox.dark-camo-gloves-upsell .close").click(function(){
  $(".grangers-productbox.dark-camo-gloves-upsell").fadeOut();
    event.preventDefault()
  setCookie("dark-camo-gloves-upsell-closed", "dark-camo-gloves-upsell-closed", 2) 
});
});

// Remove persisting spinning loading icon 

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('lazyloaded', function(e) {
    const productCard = e.target.closest('.product');
    if (productCard) {
      const spinner = productCard.querySelector('.theme-spinner');
      if (spinner) {
        spinner.style.display = 'none';
      }
    }
  });

  document.querySelectorAll('.product__img').forEach(img => {
    if (img.complete) {
      const productCard = img.closest('.product');
      if (productCard) {
        const spinner = productCard.querySelector('.theme-spinner');
        if (spinner) {
          spinner.style.display = 'none';
        }
      }
    }
  });
});

// Cart quantity UX — Make - and + auto-submit. Handle 0 as removal

$(document).ready(function () {
  // Make quantity input readonly - users must use +/- buttons
  $('.js-qty__num').prop('readonly', true);

  var removing = false;

  // Remove item when minus is clicked at qty 1
  $('.js-qty__adjust--minus').on('click', function () {
    var dataQty = parseInt($(this).data('qty'), 10);

    if (dataQty === 0) {
      removing = true;
      var itemKey = $(this).closest('.js-qty').find('.js-qty__num').data('id');
      $.post('/cart/change.js', { id: itemKey, quantity: 0 }, function () {
        window.location.reload();
      });
    }
  });

  // Auto-submit cart form on +/- click
  $('.js-qty__adjust').on('click', function () {
    if (removing) return;
    setTimeout(function () {
      $('.cart-form').submit();
    }, 100);
  });
});